export const DARCO_TEXT = 'darco';
export const RONDOM_TEXT = 'rondom';
export const ALL_TEXT = 'all';
export const DEV_ALL_TEXT = 'dev_all';
export const FRAN_HUB_TEXT = 'fran';
export const EXHIBITION_TEXT = 'exhibition';

export type GroupType = 'Standard' | 'Hub' | 0 | 1;

export class Group {
  id: number = -1;
  name: string = "";
  type: GroupType = 'Standard';
  IsRondom: boolean = false;
  IsDarco: boolean = false;
  IsAll: boolean = true;
  IsDev: boolean = false;
  IsHub: boolean = false;
  IsExhibition: boolean = false;
  
  constructor(id: number, name: string, type?: GroupType) {
    this.id = id;
    this.name = name;
    this.type = type ?? 'Standard';
    this.IsAll = this.IsAllGroup();
    this.IsRondom = this.IsRondomGroup();
    this.IsDarco = this.IsDarcoGroup();
    this.IsDev = this.IsDevGroup();
    this.IsHub = this.IsHubGroup();
    this.IsExhibition = this.IsExhibitionGroup();
  }

  IsRondomGroup = (): boolean => {
    if( this.name.toLocaleLowerCase() === RONDOM_TEXT)
        return true;
    return false;
  }

  IsAllGroup = () => {
    if( this.name.toLocaleLowerCase() === ALL_TEXT)
        return true;
    return false;

  }

  IsDarcoGroup = (): boolean => {
    if( this.name.toLocaleLowerCase() === DARCO_TEXT)
        return true;
    return false;
  }

  IsDevGroup = (): boolean => {
    if( this.name.toLocaleLowerCase() === DEV_ALL_TEXT)
        return true;
    return false;
  }

  IsHubGroup = (): boolean => {
    return this.type === 'Hub' || this.type === 1;
  }

  IsExhibitionGroup = (): boolean => {
    return this.name.toLocaleLowerCase() === EXHIBITION_TEXT;
  }
}
